import { Component, Input } from '@angular/core';
import { RequestService } from '../../services/request.service';
import { Request } from '../../types/requests/Request';

@Component({
    selector: 'las-bill-request-item',
    templateUrl: './bill-request-item.component.html',
    styleUrls: ['./bill-request-item.component.scss'],
    standalone: false,
})
export class BillRequestItemComponent {
    @Input() request = <Request>{};

    constructor(private requestService: RequestService) {}
}
